import React from 'react';
import { OFFER_ANCHOR } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2 rounded-lg border-b-4 border-[#a97b23] bg-gold px-4 py-3.5 text-center font-display text-[13px] font-bold uppercase leading-tight tracking-wide text-[#0D0D0D] shadow-lg shadow-gold/20 transition-all duration-200 hover:bg-gold-hover active:translate-y-1 active:border-b-0 sm:px-6 sm:text-base ${className}`} data-id="element-33" data-mp="2kzzfenzpr6rq">
      {children}
    </a>;
}